import type { StateCreator } from 'zustand';
import type { SliceMutators } from '~/store/mutators';
import type { Pivot } from '~/types/pipeline';

export type FramesSlice = {
  frames: {
    pivot: Pivot;
  };
  setPivot: (p: Pivot) => void;
  resetFrames: () => void;
};

const INITIAL_FRAMES = {
  pivot: { x: 0.5, y: 1 } as Pivot,
} satisfies FramesSlice['frames'];

export const createFramesSlice: StateCreator<FramesSlice, SliceMutators, [], FramesSlice> = (
  set,
) => ({
  frames: INITIAL_FRAMES,
  setPivot: (p) =>
    set((s) => {
      s.frames.pivot = p;
    }),
  resetFrames: () =>
    set((s) => {
      s.frames = { ...INITIAL_FRAMES };
    }),
});
